<template>
	<Fullscreen ref="fullscreen" @change="fullscreenChange" class="full-screen" id="full-screen">
		<md-app class="full-screen" id="app">
			<md-app-content class="full-screen md-app-content">
				
				<!-- Situation Gallery
				<transition name="slideDown">
					<SituationGallery v-show="situationGalleryVisible"/>
				</transition>
				-->
				<!-- Navigation Bar -->
				<Navigation 
					:mapVisible="mapVisible" :fullScreen="fullScreen" :loginDialogueVisible="loginDialogueVisible" :gyrosSupported="gyrosSupported"
					:gyrosActive="gyrosActive" :bugReportVisible="bugReportVisible" :situationGalleryVisible="situationGalleryVisible" :sharingVisible="sharingVisible" 
					:loggedIn="loggedIn" :comVisible="comVisible" :localUserIsModerator="localUserIsModerator" :tutorialVisible="tutorialVisible"
				/>

				<!-- Rendering -->
				<Flux360/>

				<!-- Loadingscreen between Situations -->
				<transition name="fadeLoadingscreen">
					<Loadingscreen v-show="showLoadingScreen"/>
				</transition>

				<LanguageSelection/>

				<!-- Website Dialogue -->				
				<WebsiteDialogue/>

				<!-- Preview of Transition on hover over -->
				<TransitionPreview/>

				<!-- 3D Model viewer -->
				<Viewer3D/>

				<!-- Video Fullscreen Dialogue -->				
				<VideoFullscreen/>

				<transition name="fade">
					<TutorialDialogue v-if="tutorialVisible"/>
				</transition>

				<!-- Map Dialogue-->
				<transition name="fade">
					<MapDialogue v-if="enableMap" v-show="mapVisible"/>
				</transition>

				<!-- Media Controls -->
				<transition name="fade">
					<MediaController v-show="enablePermanentPanoramaVideoControls ? isVideoPanorama: mediaControlsVisible"/>			
				</transition>

				<!-- Flux360 Watermark -->
				<Watermark v-if="enableWatermark"/>

				<Subtitles/>
			

			</md-app-content>

			<!-- Sidebar -->
			<!--md-app-drawer :md-active="comVisible" v-if="isOnboardingComplete" md-right md-persistent="full">
				<Sidebar/>
			</md-app-drawer-->

		</md-app>
	</Fullscreen>	
</template>

<script src="https://cdn.jsdelivr.net/npm/shaka-player@4.2.0/dist/shaka-player.compiled.min.js"></script>
    <script src="https://cdn.jsdelivr.net/npm/shaka-player@4.2.0/dist/shaka-player.ui.js"></script>
    <script src="shaka-loader.js"></script>
<script>
import {mapGetters,mapState,mapMutations} from 'vuex'
import {Prefab} from "@/store/flux360/PrefabDataTypes";

import Fullscreen from "vue-fullscreen/src/component.vue"

// Components
import Flux360 from "@/components/flux360/Flux360.vue";
import MapDialogue from "@/components/flux360/EmbeddedDialogues/MapDialogue/MapDialogue.vue";
import MediaController from "@/components/flux360/MediaController.vue";
import Watermark from '@/components/flux360/Watermark.vue';
import Navigation from '@/components/flux360/Navigation.vue';
import WebsiteDialogue from "@/components/flux360/EmbeddedDialogues/WebsiteDialogue.vue";
import Viewer3D from "@/components/flux360/EmbeddedDialogues/Viewer3D.vue";
import DisclaimerDialogue from "@/components/flux360/EmbeddedDialogues/DisclaimerDialogue.vue";
import Loadingscreen from "@/components/flux360/Loadingscreen.vue";
import LanguageSelection from "@/components/flux360/LanguageSelection.vue";
import TransitionPreview from "@/components/flux360/TransitionPreview";
import Sidebar from "@/components/flux360/SidebarComponents/Sidebar.vue";
import VideoFullscreen from "@/components/flux360/EmbeddedDialogues/VideoFullscreen.vue";
//import SituationGallery from "@/components/flux360/EmbeddedDialogues/SituationGallery.vue";
import TutorialDialogue from "@/components/flux360/EmbeddedDialogues/TutorialDialogue.vue";
import Subtitles from "@/components/flux360/components/Subtitles.vue";

export default {
	components: {
		Fullscreen, Flux360, MapDialogue, MediaController, Sidebar, TransitionPreview, LanguageSelection, Navigation, Watermark, TutorialDialogue,
		WebsiteDialogue, DisclaimerDialogue, Loadingscreen, Viewer3D, VideoFullscreen, Subtitles
	},
	data: () => ({
		publicPath: process.env.BASE_URL,
		comVisible: false,
		fullScreen: false,
		sharingVisible: false,
		messageVisible: false,
		situationGalleryVisible: false,
		infoVisible: false,
		mediaControlsVisible: false,
		mapVisible: false,
		screenSharingVisible: false,
		loginDialogueVisible: false,   
		loggedIn: false,
		bugReportVisible: false,
		gyrosActive: false,
		gyrosSupported: false,
		moderatorMenueVisible: false,
		tutorialVisible: false
	}),
   	computed: {
		// ...mapState(['vrMode']),
    	...mapGetters([
			'currentSituation','numberOfChatMessages', 'localUser', 'currentPrefabs','enableMap','enablePermanentPanoramaVideoControls',"enableWatermark",
			'primaryColor','secondaryColor',"fontFamily",'isDialogueOpen','loadingscreenVisible','favIcon','websiteTitle',"enableCommunication", "withSubtitles", "loadingScreenWanted"
		]),
		showLoadingScreen(){
			return this.loadingscreenVisible >=1 && this.loadingScreenWanted
		},
		// checks if currentSituation contains panorama video and if so checks if neccessary video data is loaded 
		// needed to display mediaController UI properly
		isVideoPanorama(){
			//Check if currentSituation contains panorama video if not return false
			if(!(this.currentSituation && this.currentSituation.getType() == Prefab.PrefabType.SituationVideo))
				return false;
			
			//return true when neccessary panorama video data is loaded (duration)
			return this.currentSituation.runtimeState.duration > 0;
		},

		screenSharingVisibleOrNoScreens() {
			return false;
		},
		localUserIsModerator() {
			return this.localUser && this.localUser.getRole() === "moderator"
		},
		screenCastsAvailable() {
			return false;
		},
	},
	watch: {
		screenCastsAvailable(){
			if(!this.localUserIsModerator)
				this.toggleScreenSharing(false,this.screenCastsAvailable);	
		},
		enableCommunication(){
			if(!this.enableCommunication){
				//this.toggleLoginDialogue();
				//this.toggleTutorialDialogue();
			}
				
		},
		primaryColor(){
			document.documentElement.style.setProperty('--primaryColor', this.primaryColor);
		},
		secondaryColor(){
			document.documentElement.style.setProperty('--secondaryColor', this.secondaryColor);
		},
		fontFamily(){
			document.documentElement.style.setProperty('--primaryFont', this.fontFamily);
		},
		favIcon(){
			document.querySelector("link[rel~='icon']").href = this.publicPath+'/media/'+this.favIcon;
		},
		websiteTitle(){
			document.title = this.websiteTitle;
		},
	},
	methods: {
		...mapMutations(["setDialogueOpen", "setLoadingscreenVisible"]),
		toggleLoginDialogue(){
			
			this.loginDialogueVisible = !this.loginDialogueVisible;	
			this.setDialogueOpen(this.loginDialogueVisible);
			if(this.loginDialogueVisible){
				this.situationGalleryVisible = false;
				this.mediaControlsVisible = false;
				this.sharingVisible = false;
				this.mapVisible = false;
				this.bugReportVisible = false;
				this.tutorialVisible = false;
			}	
								
		},
		toggleMediaControls() {
			this.mediaControlsVisible = !this.mediaControlsVisible;
			//this.setDialogueOpen(this.mediaControlsVisible);
			if(this.mediaControlsVisible){
				this.situationGalleryVisible = false;
				this.sharingVisible = false;
				this.mapVisible = false;
				this.bugReportVisible = false;
				this.tutorialVisible = false;
			}
		},
		toggleGallery() {
			this.situationGalleryVisible = !this.situationGalleryVisible;
			this.setDialogueOpen(this.situationGalleryVisible);
			if(this.situationGalleryVisible){
				this.mediaControlsVisible = false;
				this.sharingVisible = false;
				this.mapVisible = false;
				this.bugReportVisible = false;
				this.tutorialVisible = false;
			}
		},
		toggleTutorialDialogue(){
			this.tutorialVisible = !this.tutorialVisible;
			this.setDialogueOpen(this.tutorialVisible);
			if(this.tutorialVisible){
				this.situationGalleryVisible = false;
				this.mediaControlsVisible = false;
				this.sharingVisible = false;
				this.mapVisible = false;
				this.bugReportVisible = false;
			}
		
		},
		toggleBugReport(){
			this.bugReportVisible = !this.bugReportVisible;
			this.setDialogueOpen(this.bugReportVisible);	
			if(this.bugReportVisible){
				this.situationGalleryVisible = false;
				this.mediaControlsVisible = false;
				this.sharingVisible = false;
				this.mapVisible = false;
				this.tutorialVisible = false;
			}
		},
		toggleSharing() {
			this.sharingVisible = !this.sharingVisible;
			this.setDialogueOpen(this.sharingVisible);	
			if(this.sharingVisible){
				this.situationGalleryVisible = false;
				this.mediaControlsVisible = false;
				this.mapVisible = false;
				this.bugReportVisible = false;
				this.tutorialVisible = false;
			}
		},
		toggleMap(){
			this.mapVisible = !this.mapVisible;
      		this.setDialogueOpen(this.mapVisible);
			this.mapVisible ? document.body.style.overscrollBehaviorY = "contain": document.body.style.overscrollBehaviorY = "auto";
			if(this.mapVisible){
				this.situationGalleryVisible = false;
				this.mediaControlsVisible = false;
				this.sharingVisible = false;
				this.bugReportVisible = false;
				this.tutorialVisible = false;
			}
		},
		toggleModeratorMenue(){
			this.moderatorMenueVisible = !this.moderatorMenueVisible;
		},
		toggleScreenSharing (event, value = !this.screenSharingVisible) {
			this.screenSharingVisible = value;
			this.setDialogueOpen(this.screenSharingVisible);	
			if(this.screenSharingVisible) {
				this.situationGalleryVisible = false;
				this.mediaControlsVisible = false;
				this.sharingVisible = false;
				this.mapVisible = false;
				this.bugReportVisible = false;
				this.tutorialVisible = false;
			}
		},		
		toggleFullScreen(){
			this.$refs['fullscreen'].toggle();
		},
		toggleCommunication(){
			this.comVisible = !this.comVisible
		},
		toggleVRMode() {
			this.$store.commit('setVRMode', !this.vrMode );
		},
		fullscreenChange(fullscreen) {
			this.fullScreen = fullscreen
		},
		toggleMediaButton(value){
			this.mediaButtonVisible = value;
		},
		onbeforeunload(e) {e.preventDefault(); e.returnValue = ' ';window.returnValue = ' ';return ' '},
		toggleLogin(){
			this.loggedIn = !this.loggedIn;
			this.toggleLoginDialogue();
			if(this.loggedIn)
				window.addEventListener("beforeunload",this.onbeforeunload);
			else
				window.removeEventListener("beforeunload",this.onbeforeunload);
		},
		toggleGyros(){
			this.gyrosActive = !this.gyrosActive;
			this.$store.commit('activateGyros',this.gyrosActive);
		},
	},
	created(){
		console.defaultLog = console.log.bind(console);
        console.logs = [];
        console.error = function(){
            console.defaultLog.apply(console, arguments);
            console.logs.push(Array.from(arguments));
		}

		//this.toggleTutorialDialogue();
		//check if gyros supported
		if(window.DeviceOrientationEvent && 'ontouchstart' in window){
			this.gyrosSupported = true;
			this.$store.commit('setGyrosSupported',this.gyrosSupported);
		}
	},
	provide() {
		return {
			toggleMap: this.toggleMap,
			toggleSharing: this.toggleSharing,
			toggleGallery: this.toggleGallery,
			toggleInfo: this.toggleInfo,
			toggleLoginDialogue: this.toggleLoginDialogue,
			toggleLogin: this.toggleLogin,
			toggleCommunication: this.toggleCommunication,
			toggleBugReport: this.toggleBugReport,
			toggleScreenSharing: this.toggleScreenSharing,
			toggleMediaControls: this.toggleMediaControls,
			toggleFullScreen: this.toggleFullScreen,
			toggleGyros: this.toggleGyros,
			isVideoPanorama: this.isVideoPanorama,
			toggleModeratorMenue: this.toggleModeratorMenue,
			toggleTutorialDialogue: this.toggleTutorialDialogue,
		}
	},
}
</script>


<style>
:root{
	--primaryColor: #981e83;
  	--secondaryColor: #ffffff;
	--primaryFont: Avenir;
	--md-theme-default-primary: var(--primaryColor);
}
::selection {
	background: var(--primaryColor)! important;
}
::-moz-selection { 
	background: var(--primaryColor) !important;
}
body {
  	font-family: var(--primaryFont), Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	height: 100%;
	width: 100%;
}
/* Avoid Chrome to see Safari hack */
@supports (-webkit-touch-callout: none) {
  body {
    /* The hack for Safari */
    height: -webkit-fill-available;
  }
  .full-screen {
	/* mobile viewport bug fix */
	min-height: -webkit-fill-available;
}
}
.full-screen {
	height: 100% !important;
	width: 100% !important;
}
.md-app-content{
	padding: 0px;
	border-left: 0px;
	border-right: 0px;
	border-left: 0px;
	overflow: hidden;
	position: relative;
	top: 0px;
	left: 0px;
	padding: 0px;
}
.md-drawer.md-active{
	transform: translate3D(0,0,0);
	transition: height .5s cubic-bezier(.25,.8,.25,1), transform .4s cubic-bezier(.25,.8,.25,1);
    transition-timing-function: cubic-bezier(.25,.8,.25,1);
	box-shadow: -5px 0px 10px rgba(0, 0, 0, 0.35);
}
.material-design-icon{
	height: 2em;
	width: 2em;
}
.material-design-icon > .material-design-icon__svg{
	height: 2em;
	width: 2em;
	fill: white;
}

/* Buttonstyling*/
button{
	position:relative;
	padding: 0px 16px;

	border-radius: 0;
	border: none;

	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	gap:16px;

	cursor: pointer;
	background-color: rgb(220,220,220);
}
button::before{
	content:'';
	position: absolute;
	top:0;
	left:0;
	height:100%;
	width:100%;
	background-color: rgba(0, 0, 0, 0.0);
}
button:hover::before{
	background-color: rgba(0, 0, 0, 0.1);
}
button .icon{
	aspect-ratio: 1/1;
	height:100%;
	padding:4px;

	background-color: var(--primaryColor);
}
button.icon-right{
	flex-direction: row-reverse;
	padding-right: 0;
}
button.icon-left{
	flex-direction: row;
	padding-left: 0;
}


/*  SlideDown/SlideUp animation */
.slideDown-enter-active, .slideDown-leave-active {
	transition: max-height .2s ease-in-out;
}
.slideDown-enter, .slideDown-leave-to {
	max-height: 0px !important;
}

/*  Fade animation */
.fade-enter-active, .fade-leave-active {
	transition: opacity .4s;
}
.fade-enter, .fade-leave-to {
	opacity: 0;
}

/*  Fade animation for Loadingscreen*/
.fadeLoadingscreen-enter-active{
	transition: opacity .5s;
}
.fadeLoadingscreen-leave-active {
	transition: opacity .2s;
}
.fadeLoadingscreen-enter, .fadeLoadingscreen-leave-to {
	opacity: 0;
}
</style>